import { Paper } from '@mui/material';
import { isEmptyArray, isNotEmptyString } from '@weft/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useCustomersOverviewsForCustomersPage } from '../../../hooks/requests/use-customers-overviews/use-customers-overviews';
import { usePageParam } from '../../../hooks/search-params/use-page-param';
import { usePageSizeParam } from '../../../hooks/search-params/use-page-size-param';
import { usePaginationResetHandler } from '../../../hooks/use-pagination-reset-handler';
import { useSearchWithSearchParams } from '../../../hooks/use-search-with-search-params';
import { CustomersTable } from './customers-page-components/CustomersTable';
import { EmptyCustomersPageContent } from './customers-page-components/EmptyCustomersPageContent';

const CustomersPage: React.FC = () => {
  const [customersQuery] = useSearchWithSearchParams();
  const [page] = usePageParam();
  const [pageSize] = usePageSizeParam();

  const { data, isFetching: isFetchingCustomers, isLoading } = useCustomersOverviewsForCustomersPage({
    page,
    pageSize,
    search: isNotEmptyString(customersQuery) ? customersQuery : undefined,
  });

  usePaginationResetHandler(data?.customers.length ?? 0);

  const missingCustomers = !isLoading && isEmptyArray(data?.customers);

  return (
    <>
      <Helmet>
        <title>Customers</title>
      </Helmet>

      <VyPageLayout
        title="Customers"
      >
        <Paper sx={{
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
        >
          {
            !missingCustomers ? (
              <CustomersTable
                items={data?.customers ?? []}
                itemsCount={data?.countedFilteredCustomers ?? 0}
                loadingItems={isFetchingCustomers}
              />
            ) : <EmptyCustomersPageContent/>
          }
        </Paper>
      </VyPageLayout>
    </>
  );
};

const CustomersPageWithSuspenseBoundary = withSuspenseBoundary(withGlobalSearchParams(CustomersPage));

export { CustomersPageWithSuspenseBoundary as CustomersPage };